import { Vehicle } from '@otw/models'

export const isRefinanceVehicle = (vehicle: Pick<Vehicle, 'refinance'>): boolean =>
  vehicle.refinance === true

type NeedsTransportQueueContext = {
  vehicleIdsInTransportFlow: Set<string>
  vehicleIdsInLegacyPackages: Set<string>
  showHiddenVehicles: boolean
}

/**
 * Paid / ready-for-pickup trucks that still need to enter the transport flow.
 * Refinance trucks never belong on Needs transport — they are not picked up.
 */
export const belongsOnNeedsTransportQueue = (
  vehicle: Vehicle,
  {
    vehicleIdsInTransportFlow,
    vehicleIdsInLegacyPackages,
    showHiddenVehicles,
  }: NeedsTransportQueueContext,
): boolean => {
  if (isRefinanceVehicle(vehicle)) return false

  const isPaid = vehicle.paid_for === true
  const isReadyForPickup = vehicle.ready_for_transport?.ready_for_pickup === true
  if (!isPaid && !isReadyForPickup) return false

  if (vehicleIdsInTransportFlow.has(vehicle.id)) return false
  if (vehicleIdsInLegacyPackages.has(vehicle.id)) return false

  const isHiddenFromNeedsTransport = Boolean(
    vehicle.ready_for_transport?.hidden_from_needs_transport,
  )
  return showHiddenVehicles ? isHiddenFromNeedsTransport : !isHiddenFromNeedsTransport
}
